<!--<div class="pagebrk"></div>
  <printheaderview>
  </printheaderview>-->
<div class="row">
  <div class="col-print-12 padding-left-0px">
    <div class="card background-color-wt">
      <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px">

      </div>
      <div class="card-body padding-top-10px padding-bottom-0px font-weight-normal background-color-wt">

        <div class="row bordertop5px">
          <div class="col-print-12 text-align-center padding-top-5px">
            <label class="font-familyhead">Bill Summary(IP)</label>
            <!--<qrcode class="padding-top-0px padding-bottom-0px qr-style7" [qrdata]="PatientId" [size]="90" [level]="'M'"></qrcode>-->
          </div>
        </div>

        <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
          <div class="row margin-left-0px margin-right-0px" *ngFor="let l of CurrentAdmissionsByCodeController">
            <div class="col-print-6 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Admission No:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{l.AdmissionNo}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Admission Date:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.AdmissionDate | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
            </div>

            <div class="col-print-1"></div>

            <div class="col-print-5 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Ward / Room:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">{{l.BedLocation}} / {{l.CareUnit}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Doctor:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">{{l.ProviderIncharge}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-left">
                          Grand Total
                        </th>

                        <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family">
                          Discount
                        </th>
                        <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family">
                          Net
                        </th>
                        <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family">
                          Paid
                        </th>
                        <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family">
                          Due
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngIf="CurrentX_BillHeaderController;let RowIndex = index">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{CurrentX_BillHeaderController.TotalAmount | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{CurrentX_BillHeaderController.Discount | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{CurrentX_BillHeaderController.Net | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{CurrentX_BillHeaderController.Net - CurrentX_BillHeaderController.Balance | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{CurrentX_BillHeaderController.Balance | number:'1.2-2'}}</td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-bold">Advances:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>

                        <th class="font-weight-bold background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                          #
                        </th>

                        <th class="font-weight-bold background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Date
                        </th>

                        <th class="font-weight-bold background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Mode
                        </th>
                        <th class="font-weight-bold background-primary text-align-right padding-top-2px padding-bottom-2px font-family">
                          Amount
                        </th>


                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of CurrentBillAdvancesListController;let RowIndex = index">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{RowIndex+1}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.BillDate | date:'MMM-dd-yyyy'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.PaymentInstrument}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{l.AdvanceAmount | number:'1.2-2'}}</td>

                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-bold">Payment Details:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-left">
                          #
                        </th>

                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Date
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Rec.No
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Pay Mode
                        </th>
                        <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family">
                          Amount
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of CurrentX_BillReceiptsController;let RowIndex = index">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{RowIndex+1}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.ReceiptDate | date:'MMM-dd-yyyy'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.FormattedCode}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.PaymentInstrument}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{l.ReceivedAmount | number:'1.2-2'}}</td>

                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <!--<div class="col-print-12">
    <div class="row margin-left-0px margin-right-0px">
      <div class="col-print-10">
        <label class="margin-bottom-0px font-family font-weight-normal">Amount In Words: {{Net - Due | amountToWord}}</label>
      </div>
      <div class="col-print-2">
        <label class="margin-bottom-0px font-family float-left font-weight-bold">{{Net - Due | number:'1.2-2'}}</label>
      </div>
    </div>
  </div>-->
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-5">
              <label class="margin-bottom-0px font-family font-weight-normal">Cashier:</label>
            </div>
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              t-
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-5">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <!--<div class="col-print-1">
        <label class="margin-bottom-0px font-family font-weight-bold">(</label>
      </div>-->
            <div class="col-print-5" *ngIf="CurrentX_BillHeaderController">
              <label class="margin-bottom-0px font-family font-weight-normal">( {{CurrentX_BillHeaderController.PayeeName}} )</label>
            </div>
            <!--<div class="col-print-1">
        <label class="margin-bottom-0px font-family font-weight-bold">)</label>
      </div>-->
            <div class="col-print-4">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <!--<div class="col-print-12">
    <div class="row margin-left-0px margin-right-0px">
      <div class="col-print-2">
        <label class="margin-bottom-0px font-family font-weight-bold">Due:</label>
      </div>
      <div class="col-print-6">
        <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Due}}</label>
      </div>
    </div>
  </div>-->
      </div>
    </div>
  </div>
</div>
<!--<printfooterview></printfooterview>-->
